import { StatusOption } from '../../utils'

export enum LanguageLevelEnum {
  NOT_PRACTICED = 'NOT_PRACTICED',
  AVERAGE = 'AVERAGE',
  GOOD = 'GOOD',
  VERY_GOOD = 'VERY_GOOD'
}

export const languageLevelEnumMapping: Record<LanguageLevelEnum, StatusOption> = {
  [LanguageLevelEnum.NOT_PRACTICED]: {
    label: 'Non pratiqué',
    variant: 'danger'
  },
  [LanguageLevelEnum.AVERAGE]: {
    label: 'Moyen',
    variant: 'warning'
  },
  [LanguageLevelEnum.GOOD]: {
    label: 'Bon',
    variant: 'purple'
  },
  [LanguageLevelEnum.VERY_GOOD]: {
    label: 'Très bon',
    variant: 'success'
  }
}
